
    const initSwipers = () => {
    const wrappers = document.querySelectorAll('.swiper-block-wrapper');

    wrappers.forEach((wrapper) => {
      if (wrapper.dataset.initialized === 'true') return;

      const mainEl = wrapper.querySelector('.dksubswiper');
      const thumbEl = wrapper.querySelector('.dkdetailmswiper');
      const nextBtn = wrapper.querySelector('.swiper-button-next');
      const prevBtn = wrapper.querySelector('.swiper-button-prev');

      if (mainEl && thumbEl) {
        // 3. 先初始化缩略图 (文字版)
        const currentThumbsSwiper = new Swiper(thumbEl, {
          loop: false,
          slidesPerView: 'auto',
          spaceBetween: 12,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          freeMode: true,
          breakpoints: {
            768: {
              centeredSlides: true,
              centeredSlidesBounds: true,
              spaceBetween: 20,
              freeMode: false,
            },
          },
        });

        // 4. 初始化主图，并精确绑定上面这个缩略图实例
        new Swiper(mainEl, {
          loop: true,
          spaceBetween: 10,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
          thumbs: {
            swiper: currentThumbsSwiper,
          },
          grabCursor: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
        });

        // 标记该容器已完成初始化
        wrapper.dataset.initialized = 'true';
      }
    });
  };

  // 初次加载执行
  initSwipers();

  // 针对 Shopify 编辑器动态添加 Block 的兼容处理
  document.addEventListener('shopify:section:load', initSwipers);

  const initSwiperGroups = () => {
    const swiperGroups = document.querySelectorAll('.dkmainswiper');

    swiperGroups.forEach((group) => {
      if (group.dataset.initialized === 'true') return;

      const mainEl = group.querySelector('.dk3imgswiper');
      const thumbEl = group.querySelector('.mySwiper');
      const nextBtn = group.querySelector('.swiper-button-next');
      const prevBtn = group.querySelector('.swiper-button-prev');

      if (!mainEl || !thumbEl) return;

      // 解析当前容器独有的文字数组
      // 我们可以从 data-captions 属性中通过 "|" 分割出数组
      const rawCaptions = group.dataset.captions || "";
      const blockCaptions = rawCaptions.split('|');

      const currentThumbsSwiper = new Swiper(thumbEl, {
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 12,
        watchSlidesProgress: true,
        grabCursor: true,
        slideToClickedSlide: true,
        freeMode: true,
        breakpoints: {
          768: {
            centeredSlides: true,
            centeredSlidesBounds: true,
            spaceBetween: 20,
            freeMode: false,
          },
        },
      });

      new Swiper(mainEl, {
        loop: true,
        spaceBetween: 10,
        navigation: { nextEl: nextBtn, prevEl: prevBtn },
        thumbs: { swiper: currentThumbsSwiper },
        grabCursor: true,
        autoplay: { delay: 5000, disableOnInteraction: false },
        on: {
          init: function () {
            updateCaption(this, group, blockCaptions);
          },
          slideChange: function () {
            updateCaption(this, group, blockCaptions);
          },
        },
      });

      function updateCaption(swiperInstance, container, captionsArray) {
        const realIndex = swiperInstance.realIndex;
        // 直接从传入的属于该 block 的数组里取值
        const newText = captionsArray[realIndex] || captionsArray[0] || "";
        
        const targetTitle = container.querySelector('.sub_title');
        if (targetTitle) {
          targetTitle.textContent = newText;
        }
      }

      group.dataset.initialized = 'true';
    });
  };

  initSwiperGroups();
  document.addEventListener('shopify:section:load', initSwiperGroups);